export default __webpack_public_path__ + "static/slider-5-8edb73acad9f5d62000b1ef1ddc700c0.jpg";